import { render, staticRenderFns } from "./cwmxorder.vue?vue&type=template&id=a2a45702&"
import script from "./cwmxorder.vue?vue&type=script&lang=js&"
export * from "./cwmxorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports